<template>
  <b-container fluid="true" style="margin:20px; max-width: 1000px;" :id="`questionId-${id}`">
    <b-row :id="`row-${ id }`" :style="`padding-right: 5px;`">
      <b-col sm="4" style="padding-left: 0">
        <div style="padding-left: 0; padding-right: 10px">
          <font-awesome-icon class="handle" :icon="['fas', 'bars']" size="1x"/>
        </div>
      </b-col>
      <b-col cols="6">
      </b-col>
      <b-col cols="2" class="text-right">
        <div style="float: right; padding-top: 5px; padding-right: 5px; vertical-align: top;">
          <font-awesome-icon icon="minus-circle" size="1x" @click="removeMe"/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="10" style="font-size: x-large;"><span class="question-number">{{ qnum }}.</span><span
          class="question-text"><ckeditor :editor="editor" v-model="qText" :config="editorConfig"
                                          @input="setSaveable">
      </ckeditor>
      </span>
      </b-col>
      <b-col sm="2">
        <b-button id="saveButton" @click="saveChanges" :disabled="saveable" :variant="buttonVariant">
          Save
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2" class="green-note-label text-right align-top">Green Note:</b-col>
      <b-col sm="9" class="green-note">
        <ckeditor :editor="editor" v-model="greenNote" :config="editorConfig"
                  @input="setSaveable"></ckeditor>
      </b-col>
    </b-row>
    <b-row v-if="questionType === 'MATRIX'">
      <b-col style="text-align: center; width: 100%;">
        <b-form-radio-group
            v-model="selectedResponse">
          <b-form-radio :style="getRadioStyle(options)"
                        v-for="option in columns"
                        :key="option"
                        :value="option"
                        name="flavour-3a"
                        size="lg"
                        @change="reportValue($event)"
          >
            {{ option }}
          </b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row v-else-if="questionType === 'CHECKBOX'">
      <b-col style="text-align: left; width: 100%; padding-left: 40px; font-size: large">
        <b-form-group>
          <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="selectedResponse"
              :options="choices"
              name="flavour-1"
              size="lg"
              stacked
              @change="reportValue($event)"
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-else-if="questionType === 'COMMENT'">
      <b-col style="text-align: center; width: 100%; font-size: large">
        <b-form-group>
          <b-textarea v-model="selectedResponse" @change="reportValue($event)"></b-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

//import InlineEditor from "@ckeditor/ckeditor5-build-inline";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import InlineEditor from "@ckeditor/ckeditor5-editor-inline/src/inlineeditor";
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Bus from "@/eventBus";


export default {
  name: "VineyardQuestionEditor",
  props: {
    qValue: Object,
    num: Number,
    response: [String, Array]
  },
  components: {
    'ckeditor': CKEditor.component,
  },
  data() {
    return {
      options: this.qValue.options,
      choices: this.qValue.choices,
      columns: this.qValue.columns,
      selectedResponse: this.response,
      qText: this.qValue.text,
      greenNote: this.qValue.greenNote,
      qnum: this.num, //this.qValue.qnum,
      questionId: this.qValue.questionId,
      name: this.qValue.name,
      questionType: this.qValue.controlType,
      id: this.qValue._id,
      colCount: this.qValue.colCount,
      creationDate: this.qValue.creationDate,
      type: this.qValue.type,
      creatorId: this.qValue.creatorId,
      title: this.qValue.title,

      editorConfig: {
        link: {
          decorators: {
            addTargetToExternalLinks: true,
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            },
            openInNewTab: {
              mode: 'manual',
              label: 'Open in a new tab',
              defaultValue: true,			// This option will be selected by default.
              attributes: {
                target: '_blank',
                rel: 'noopener noreferrer'
              }
            }
          }
        },
        plugins: [
          EssentialsPlugin,
          BoldPlugin,
          ItalicPlugin,
          LinkPlugin,
          ParagraphPlugin
        ],
        toolbar: ['Image', 'heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2'}
          ]
        }
      },
      editor: InlineEditor,
      saveable: true,
      buttonVariant: "outline-primary"
    }
  },
  watch: {
    num: function (val) {
      this.qnum = val;
    }
  },
  mounted() {
    if (this.questionType === "CHECKBOX") {
      console.log("Question Id: " + this.id);
      console.log("Answer: " + this.selectedResponse);
    }
  },
  methods: {
    getRadioStyle: function (optionsList) {
      if (!optionsList) {
        return "font-size: x-large"
      }
      let numbOfOptions = optionsList.length;
      let padding = Math.floor(((100 - (5 * numbOfOptions)) / (numbOfOptions + 1)) / 2);
      return 'padding-left:' + padding + '%; padding-right:' + padding + '%; font-size: x-large;'
    },
    reportValue: function (event) {
    },
    toQuestion: function () {
      let quest = {
        choices: this.choices,
        columns: this.columns,
        colCount: this.colCount,
        text: this.qText,
        greenNote: this.greenNote,
        qnum: this.qnum,
        questionId: this.questionId,
        name: this.name,
        controlType: this.questionType,
        creationDate: this.creationDate,
        creatorId: this.creatorId,
        hasNone: this.hasNone,
        title: this.title,
        type: this.type,

        _id: this.id,
      }
      return quest;
    },
    saveChanges: function () {
      this.$toasted.show(`Question Id: ${this.id}, Selected Value ${this.qText}`,
          {
            containerClass: 'super-toasty',
            iconPack: 'fontawesome',
            closeOnSwipe: true,
            action: {
              text: 'DISMISS',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            },
            icon: {
              name: 'fa-check-circle',
              after: false,
            }
          })
          .goAway(5000);

      let surveyQuestion = this.toQuestion();
      let surveyJson = JSON.stringify(surveyQuestion, null, 3);
      this.$http.put(`vineyard/measure`, surveyJson, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(result => {
            if (result.status === 202) {
              if (result.data) {
                self.lastUpdatedDate = result.data.lastUpdatedDate;
                /*                Swal.fire({
                                  title: 'Checklist Saved',
                                  text: 'Your Checklist Has Been Save Successfully.',
                                  icon: 'success'
                                });*/
                this.$toasted.info("Question Saved Successfully", {
                  containerClass: 'super-toasty',
                  iconPack: 'fontawesome',
                  closeOnSwipe: true,
                  action: {
                    text: 'DISMISS',
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    }
                  },
                  icon: {
                    name: 'fa-save',
                    after: false
                  }
                })
                    .goAway(5000);
              } else {

                self.resolutionMap = response.data.differenceMap;
                self.currentResolutionQuestion = Object.keys(self.resolutionMap)[0];
                self.theirResponse = this.getResponseOrUnanswered(self.resolutionMap[self.currentResolutionQuestion][0]);
                self.myResponse = this.getResponseOrUnanswered(self.resolutionMap[self.currentResolutionQuestion][1]);
                self.currentResolutionNumber = 1;
                this.$bvModal.show("modal-1");
              }

            }
          }).catch(
          error => {
            console.log(error)
          });

      this.saveable = false;
      this.buttonVariant = "outline-primary";
    },
    setSaveable: function () {
      this.saveable = false;
      this.buttonVariant = "success";
    },
    removeMe: function () {
      Bus.$emit("delete-question", this.id, this.type);
    }
  },
  computed: {}

}
</script>

<style scoped>
p {
  display: flex;
  width: 600px;
}

p:before {
  padding-right: 4px;
}

.question-number {
  position: absolute;
  top: 0;
  left: 0;
  margin-right: 5px;
  text-align: right;
}

.question-text {
  padding-left: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  width: 100%;
  font-size: 20px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: inline-block;
}

.question-text >>> a {
  color: #28763a;
}

.green-note-label {
  color: #1c7430;
  margin-left: 15px;
  margin-top: 0;
  padding-top: 0;
  font-size: 16px;
  font-style: italic;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.green-note {
  color: #1c7430;
  margin-left: -5px;
  margin-top: 0;
  font-size: 16px;
  font-style: italic;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: inline-block;
}

a {
  color: darkgreen;
  font-family: "Times New Roman"
}

a:visited {
  color: orange;
}

a:link {
  color: #28763a;
}

</style>
